import React, { Component } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import ViewMore from '../common/ViewMore'

export default class ThirdPartyItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode } = this.props

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell>
          <EditableSelect
            value={data.accountType}
            onChange={this.onChange('accountType')}
            valueToRender={data.accountType}
            editMode={editMode}
          >
            <MenuItem value="None">None</MenuItem>
            <MenuItem value="CashVault">CashVault</MenuItem>
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.username}
            editMode={editMode}
            value={data.username}
            onChange={this.onChange('username')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {editMode ? (
            <EditableTextField
              valueToRender={data.password}
              editMode={editMode}
              value={data.password}
              onChange={this.onChange('password')}
              type="text"
              InputLabelProps={{
                shrink: true,
              }}
            />
          ) : (
            <ViewMore text={data.password || ''} />
          )}
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ThirdParty/ThirdPartyItem.js